import { UserModel } from "@/models";

export class Page {
  /**
   * Whether a user can manage an existing page.
   *
   * @param {User=} user
   * @returns {boolean}
   */
  public static canDelete(user?: UserModel): boolean {
    if (!user) {
      return false;
    }
    return user.hasPermission("pages.manage");
  }

  /**
   * Whether a user can manage an existing page.
   *
   * @param {User=} user
   * @returns {boolean}
   */
  public static canManage(user?: UserModel): boolean {
    if (!user) {
      return false;
    }
    return user.hasPermission("pages.manage");
  }
}

export default Page;
